import { useState } from "react";
import { navLinks } from "@/mocks/home";

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full max-w-[1280px] items-center gap-4 px-4 md:px-6">
        <h1 className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
            <i className="ri-fire-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              爆料黑料
            </span>
            <span className="mt-0.5 text-[10px] tracking-[0.18em] text-foreground-500">
              全网黑料整理
            </span>
          </span>
        </h1>

        <nav className="ml-4 hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto hidden items-center gap-3 lg:flex">
          <label className="flex h-9 items-center gap-2 rounded-full border border-background-200 bg-background-100/80 px-3.5">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-search-line text-sm text-foreground-500"></i>
            </span>
            <input
              type="text"
              aria-label="搜索合集、话题或关键词"
              placeholder="搜合集 / 话题 / 关键词"
              className="w-40 bg-transparent text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none"
            />
          </label>
          <span className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1.5 text-xs font-medium text-primary-800">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-refresh-line"></i>
            </span>
            今日已更 218 条
          </span>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="打开导航菜单"
          className="ml-auto flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/80 bg-background-50 px-4 pb-4 pt-3 md:hidden">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer rounded-md px-2 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <label className="mt-2 flex h-10 items-center gap-2 rounded-md border border-background-200 bg-background-100/80 px-3">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-search-line text-sm text-foreground-500"></i>
            </span>
            <input
              type="text"
              aria-label="搜索合集、话题或关键词"
              placeholder="搜合集 / 话题 / 关键词"
              className="w-full bg-transparent text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none"
            />
          </label>
        </div>
      )}
    </header>
  );
}